import { Injectable } from '@angular/core';
import { Client, ISizeId } from '@df/core/service/client';
import { NDfs } from '../dfs.interfaces';

@Injectable({
    providedIn: 'root'
})
export class DfsPerSizeNormalizeService {
    constructor(private client: Client) {}
    execute<T>(value: NDfs.TPerSize<T> | T | undefined, sizeId: ISizeId = this.client.sizeId): T | undefined {
        if (typeof value === 'undefined') {
            return value;
        }
        return Array.isArray(value) ? value[sizeId || this.client.sizeId] : value;
    }
}
